import "./Footer.css";

export function Footer() {
  return (
    <div className="footer-section">&#169; Copyright HashFit Inc 2026</div>
  );
}
